/**
 * InApp Dataset for read/write in-app data operations 
 */
export const InAppDatasets = (function () {

    var load = {

        /**
         * Function that is called when the file is loaded
         */
        pds: function () {
            $('.inapp-table').each(function () {
                load.displayTables(this);
            });
        },

        /**
         * Retrieve the table data from the inapp ds endpoint.
         * Dataset name is on the parameter not ID parameter, we need to remove the `table_` from the end
         * We then iterate the `table` node and get all the fields names, removing the `-th` suffix
         * Finally the full table ID is passed to .addTableData which displays the data (Note
         * this is a function from the DataProcessing.js) 
         * @param {*} table 
         */
        displayTables: function (table) {

            var tableID = $(table).attr("id");
            var dataset = tableID.replace('table_', '');

            /**
             * Get the fields in the form (remove the -th suffix)
             * Hold in an array to be passed to the ajax call
             */
            var fields = [];
            $(table).find("th").each(function () { 
                fields.push($(this).attr("id").slice(0,-3));
            })

            return $.ajax({
                url: '/inapp/dataset/' + dataset,
                type: 'post',
                dataType: 'json',
                data: {
                    dataset: dataset,
                    type: 'transactional',
                    fields: fields
                },
            }).then(function (response) { //

                /**
                 * Display the table data.  Note this uses the function from the DataProccessing.js
                 */
                DataProcessing.load.addTableData(response, tableID);

            }).fail(function (e) {
                console.log(e);
            });
        },
    
    }
    return {
        load: load
    }

}());
window.onload = InAppDatasets.load.pds();


